module.exports = __webpack_public_path__ + "static/media/CrossButton.24b31224.svg";